import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { services } from "../../data/services";
import socialLinks from "../../rs.json";
import { motion } from "framer-motion";

const Footer = () => {
    const currentYear = new Date().getFullYear();
    const navigate = useNavigate();

    return (
        <footer className="bg-gray-900 text-gray-400 py-16 relative">
            <div className="container mx-auto px-6 relative z-10">
                {/* Main footer content */}
                <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-16">
                    {/* Left section - Logo and tagline */}

                    <motion.div
                        className="transition-all duration-300"
                        initial={{ opacity: 0 }}
                        whileInView={{ opacity: 1 }}
                        viewport={{ once: true }}
                        transition={{ duration: 0.7 }}
                    >
                        <div className="mb-6">
                            <img
                                src="/images/nyloria-logo-white.svg"
                                alt="Nyloria Logo"
                                className="h-12 mb-4"
                            />
                            <span className="text-3xl text-white font-semibold title">
                                Nyloria
                            </span>
                        </div>
                        <p className="text-gray-400 max-w-md mt-4">
                            Faisons quelque chose de grand ensemble.
                        </p>
                    </motion.div>

                    {/* Middle section - Company links */}
                    <div className="flex">
                        <motion.div
                            className="transition-all duration-300"
                            initial={{ opacity: 0 }}
                            whileInView={{ opacity: 1 }}
                            viewport={{ once: true }}
                            transition={{ duration: 0.7, delay: 0.1 }}
                        >
                            <div>
                                <h3 className="text-lg font-medium text-white mb-6">
                                    SERVICES
                                </h3>
                                <ul className="space-y-3">
                                    {services.map((service, index) => (
                                        <li>
                                            <Link
                                                key={service.id}
                                                to={`/#services?service=${service.id}`}
                                                className="text-gray-400 hover:text-white transition-colors"
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    navigate(
                                                        `/#services?service=${service.id}`
                                                    );
                                                    window.dispatchEvent(
                                                        new CustomEvent(
                                                            "serviceSelected",
                                                            {
                                                                detail: {
                                                                    serviceId:
                                                                        service.id,
                                                                },
                                                            }
                                                        )
                                                    );
                                                }}
                                            >
                                                {service.shortTitle}
                                            </Link>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        </motion.div>
                    </div>

                    {/* Right section - Social links */}
                    <div className="flex">
                        <motion.div
                            className="transition-all duration-300"
                            initial={{ opacity: 0 }}
                            whileInView={{ opacity: 1 }}
                            viewport={{ once: true }}
                            transition={{ duration: 0.7, delay: 0.1 }}
                        >
                            <div>
                                <h3 className="text-lg font-medium text-white mb-6">
                                    RÉSEAUX
                                </h3>
                                <ul className="space-y-3">
                                    <li>
                                        <a
                                            href={socialLinks.linkedin || "#"}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="text-gray-400 hover:text-white transition-colors"
                                        >
                                            Linkedin
                                        </a>
                                    </li>
                                    <li>
                                        <a
                                            href={socialLinks.twitter || "#"}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="text-gray-400 hover:text-white transition-colors"
                                        >
                                            Twitter
                                        </a>
                                    </li>
                                    <li>
                                        <a
                                            href={socialLinks.instagram || "#"}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="text-gray-400 hover:text-white transition-colors"
                                        >
                                            Instagram
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </motion.div>
                    </div>
                </div>

                {/* Contact info section */}
                <div className="border-t border-gray-800 pt-8 pb-6 flex flex-col md:flex-row justify-between items-center">
                    <div className="mb-4 md:mb-0">
                        <h4 className="text-sm uppercase font-medium text-gray-500 mb-2">
                            EMAIL
                        </h4>
                        <a
                            href="mailto:contact@nyloria.fr"
                            className="text-gray-400 hover:text-white transition-colors"
                        >
                            contact@nyloria.fr
                        </a>
                    </div>

                    <div className="text-center md:text-right">
                        <p className="text-gray-500">
                            &copy; {currentYear} Nyloria
                        </p>
                    </div>
                </div>

                {/* Footer bottom section */}
                <div className="text-xs text-gray-500 text-center border-t border-gray-800 pt-6">
                    <p>
                        This site is protected by reCAPTCHA and the Google
                        privacy policy and terms of service apply. You must not
                        use this website if you disagree with any of these
                        website standard terms and conditions.
                    </p>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
